// src/composables/useLocale.ts
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import type { LocaleType } from "@/i18/index";

export function useLocale() {
  const { locale, t } = useI18n();

  const currentLocale = computed(() => locale.value as LocaleType);

  const localeLabel = computed(() => {
    return locale.value === "zh-CN" ? t("nav.english") : "中文";
  });

  const loginLabel = computed(() => {
    return t("nav.login");
  });

  const toggleLocale = () => {
    const newLocale: LocaleType = locale.value === "zh-CN" ? "en" : "zh-CN";
    locale.value = newLocale;
    localStorage.setItem("app-locale", newLocale);
  };

  const setLocale = (lang: LocaleType) => {
    locale.value = lang;
    localStorage.setItem("app-locale", lang);
  };

  return {
    currentLocale,
    localeLabel,
    loginLabel,
    toggleLocale,
    setLocale,
  };
}
